export default "__VITE_ASSET__B0c0e_vI__"